export const getUrl = (url: string) =>
  url?.startsWith('/api')
    ? `${
        process.env.NODE_ENV === 'development'
          ? ''
          : process.env.NEXT_PUBLIC_DOMAIN
      }${url}`
    : url;

export const getAvatarUrl = (userId: string, folderPath: 'staff' | 'company') =>
  `${process.env.NEXT_PUBLIC_DOMAIN}/images/${folderPath}/${userId}.png`;
